


































import { Component, Vue } from 'vue-property-decorator'
import OpenSeadragon from 'openseadragon'
@Component({})
export default class OpenSeadragonComponent extends Vue {
  private webPoint: string = ''
  private viewportPoint: string = ''
  private imagePoint: string = ''
  private zoom: string = ''
  private imageZoom: string = ''

  private mounted() {
    const viewer: any = OpenSeadragon({
      id: 'contentDiv',
      prefixUrl: '/images/',
      tileSources: '/data/wide.dzi',
      // tileSources:
      //   'https://openseadragon.github.io/example-images/duomo/duomo.dzi',
      showNavigator: true
    })
    const self = this
    viewer.addHandler('canvas-click', (e: any) => {
      self.webPoint = e.position
      self.viewportPoint = viewer.viewport.pointFromPixel(self.webPoint)
      self.imagePoint = viewer.viewport.viewportToImageCoordinates(
        self.viewportPoint
      )
    })

    const updateZoom = () => {
      const zoom = viewer.viewport.getZoom(true)
      const imageZoom = viewer.viewport.viewportToImageZoom(zoom)
      self.zoom = (Math.round(zoom * 100) / 100).toString()
      self.imageZoom = (Math.round(imageZoom * 100) / 100).toString()
    }

    viewer.addHandler('open', () => {
      const tracker = new OpenSeadragon.MouseTracker({
        element: viewer.container,
        moveHandler: (event: any) => {
          self.webPoint = event.position
          self.viewportPoint = viewer.viewport.pointFromPixel(self.webPoint)
          self.imagePoint = viewer.viewport.viewportToImageCoordinates(
            self.viewportPoint
          )
          const zoom = viewer.viewport.getZoom(true)
          const imageZoom = viewer.viewport.viewportToImageZoom(zoom)

          updateZoom()
        }
      })

      tracker.setTracking(true)

      viewer.addHandler('animation', updateZoom)
    })
  }
}
